import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
    getHasServices,
    getIsSubmitSuccessful,
    getBooking,
    getRoute,
    getShowMap,
    getEditingService,
    getHasRoute,
    getShowSubmit,
    getServiceType,
} from "../../../data/booking/selectors/booking";
import SubmitConfirmationLeftColumn from "../components/submit_confirmation/LeftColumn";
import Map from "../components/map/leaflet/Map";
import ImageBackground from "../components/ImageBackground";


class LeftContentContainer extends Component {
    static propTypes = {
        hasServices: PropTypes.bool,
        showSubmitSuccess: PropTypes.bool,
        booking: PropTypes.object,
        route: PropTypes.object,
    };

    render() {
        const {
            showSubmitSuccess,
        } = this.props;

        if (showSubmitSuccess) {
            return <SubmitConfirmationLeftColumn  />;
        }

        // We have at least one service so we render summary
        return <Map />;
    }
}

export default connect(
    (state) => ({
        showMap: getShowMap(state.booking),
        editedService: getEditingService(state.booking),
        serviceType: getServiceType(state.booking),
        hasServices: getHasServices(state.booking),
        showSubmitSuccess: getIsSubmitSuccessful(state.booking),
        booking: getBooking(state.booking),
        route: getRoute(state.booking),
    }),
    null
)(LeftContentContainer);
